module.exports = __webpack_public_path__ + "media/10 Sec Countdown.2e24ae13.mp3";